import type { CancelReasonView } from "@planerius/contracts/cabinet"
import { useEffect, useState } from "react"

import { fetchCancelReasons } from "../../api/journal.api"

/**
 * Справочник причин отмены.
 *
 * ЗАГРУЖАЕТСЯ ЗАРАНЕЕ, А НЕ В МОМЕНТ ОТКРЫТИЯ ДИАЛОГА. Администратор уже нажал
 * «Отменить» — он говорит с клиентом по телефону, и ждать ещё один запрос ему негде.
 * Справочник маленький и меняется раз в год, поэтому он едет вместе с днём.
 *
 * ОТКАЗ НЕ ЛОМАЕТ ЭКРАН. Без причин диалог отмены показать нельзя (reasonCode
 * обязателен), поэтому пустой список — это состояние, которое диалог объясняет словами,
 * а не белый экран поверх журнала.
 */
export function useCancelReasons(enabled: boolean): readonly CancelReasonView[] {
  const [reasons, setReasons] = useState<readonly CancelReasonView[]>([])

  useEffect(() => {
    if (!enabled || reasons.length > 0) return
    const controller = new AbortController()
    void (async () => {
      try {
        const loaded = await fetchCancelReasons({}, controller.signal)
        if (!controller.signal.aborted) setReasons(loaded)
      } catch {
        // Молча: причины нужны одному диалогу, и он сам скажет, что их нет.
      }
    })()
    return () => {
      controller.abort()
    }
  }, [enabled, reasons.length])

  return reasons
}
